import { TradeRateGroupType } from "./TradeRateGroupType";

export class TradeRate {
  public grouping: TradeRateGroupType;
  public groupingStr: string;
  public instrument: string;
  public spotRate: string;
  public fwdPts: string;
  public allIn: string;
  public localBook: string;
  public remoteBook: string;
}
